import React from 'react';
import '../../styles/vaultinum.css';
import VAULTINUM_CONTENT from '../components/landingPage/VaultinumPage/vaultinumContent';
import {
    VltHeader, VltHero, VltBenefits, VltDocker, VltFlow,
    VltScore, VltScreens, VltPricing, VltFinal,
} from '../components/landingPage/VaultinumPage/VaultinumSections';

/**
 * Diligentsia x Vaultinum — the Technology tab destination, opened in a new browser tab.
 *
 * All three personas share the same eight sections; only the copy differs, so every section is
 * driven by VAULTINUM_CONTENT rather than duplicated per audience.
 *
 * @param {'company'|'advisor'|'investor'} persona - which audience this page addresses
 */
const VaultinumPage = ({ persona = 'company' }) => {
    const c = VAULTINUM_CONTENT[persona] || VAULTINUM_CONTENT['company'];

    return (
        <div className="dlg-vaultinum-module">
            <VltHeader />
            <VltHero c={c['VltHero']} />
            <VltBenefits c={c['VltBenefits']} />
            <VltDocker c={c['VltDocker']} />
            <VltFlow c={c['VltFlow']} />
            <VltScore c={c['VltScore']} />
            <VltScreens c={c['VltScreens']} />
            <VltPricing c={c['VltPricing']} />
            <VltFinal c={c['VltFinal']} />
        </div>
    );
};

export default VaultinumPage;
